export default "__VITE_ASSET__DBC7WDLE__"